import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const icp = {
    jpath: ['spectra', 'icp'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default icp;
//# sourceMappingURL=icp.js.map